export enum BanStatus {
  Banned = 'banned',
  Allowed = 'allowed',
}
